import React, { useState, useEffect } from "react";
import { Form, Modal, Button, Typography, Row, Col } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import Draggable from "react-draggable";
import { DatePickerItem } from "../../../components/forms/FormItems";
import CheckBoxItem from "../../../components/forms/CheckBoxItem";
import moment from "moment";

const { Title } = Typography;

const ExportMeserModal = ({
  visible,
  onHide,
  onSubmit,
  title,
  btnText,
  initialValues,
  loading,
}) => {
  const [disabled, setDisabled] = useState(true);
  const [form] = Form.useForm();
  const [showDatePicker, setShowDatePicker] = useState(false);

  useEffect(() => {
    form.setFieldsValue(initialValues);
    return () => form.resetFields();
  }, [visible, initialValues]);

  const onCancel = () => {
    onHide();
  };

  // Add cleanup effect when modal becomes invisible
  useEffect(() => {
    if (!visible) {
      setShowDatePicker(false);
      form.resetFields();
    }
  }, [visible]);

  const onMouseOver = () => setDisabled(false);
  const onMouseOut = () => setDisabled(true);

  const onValuesChange = (changedValues) => {
    if (changedValues.hasOwnProperty("incremental")) {
      setShowDatePicker(!changedValues.incremental);
    }
  };

  const onFinish = (values) => {
    const payload = {
      ...values,
      month: values.month ? +moment(values.month).format("M") : undefined,
      year: values.month ? +moment(values.month).format("YYYY") : undefined,
    };
    onSubmit(payload);
  };

  return (
    <Modal
      closable={false}
      footer={null}
      maskClosable={false}
      title={null}
      width="400px"
      styles={{ body: { padding: 0 } }}
      open={visible}
      modalRender={(modal) => (
        <Draggable disabled={disabled}>{modal}</Draggable>
      )}
    >
      <div>
        <div
          style={{
            width: "100%",
            cursor: "move",
            height: "50px",
            position: "absolute",
            left: "0",
            top: "0",
          }}
          onMouseOver={onMouseOver}
          onMouseOut={onMouseOut}
        >
          <Button
            style={{ position: "absolute", left: 10, top: 10 }}
            type="text"
            shape="circle"
            icon={<CloseOutlined />}
            onClick={onCancel}
          />
        </div>
        <div style={{ padding: "40px" }}>
          <Title
            level={4}
            style={{ textAlign: "center", marginBottom: "20px" }}
          >
            {title}
          </Title>

          <Form
            form={form}
            onFinish={onFinish}
            onValuesChange={onValuesChange}
            layout="vertical"
          >
            <CheckBoxItem
              name="incremental"
              category="component"
              defaultChecked={true}
            />

            {showDatePicker && (
              <DatePickerItem
                name="month"
                category="component"
                picker="month"
                format="MM/YYYY"
                required={true}
              />
            )}

            <Row justify="center" style={{ marginTop: "20px" }}>
              <Button type="primary" htmlType="submit" loading={loading}>
                {btnText}
              </Button>
            </Row>
          </Form>
        </div>
      </div>
    </Modal>
  );
};

export default ExportMeserModal;
